import React, { Component, Fragment } from 'react'
import moment from 'moment';
import { QRCodeSVG } from 'qrcode.react';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

const formatNumber = {
  separador: ',', // separador para los miles
  sepDecimal: '.', // separador para los decimales
  formatear: function (num) {
    num += '';
    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    let regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
    }
    return this.simbol + splitLeft + splitRight;
  },
  new: function (num, simbol) {
    this.simbol = simbol || '';
    if (typeof num == 'undefined') {
      num = 0;
    }
    if (isNaN(num)) {
      return num;
    }
    return this.formatear(Number(num).toFixed(2));
  },
};

class CollectInvoice extends Component {

  RefreshDocModel = async (EditableDocModel) => {
    const { RefreshDocModel } = this.props;
    await RefreshDocModel(EditableDocModel);
    this.forceUpdate();
  }

  OnchangeBillStreet = async (value) => {
    const { EditableDocModel } = this.props;
    EditableDocModel.street = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillCounty = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.county = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillCity = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.city = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillBlock = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.block = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeRFC = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.rfc = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipStreet = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipStreet = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipCounty = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipCounty = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipCity = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipCity = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipBlock = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipBlock = value;
    this.RefreshDocModel(EditableDocModel)
  }

  EqualDataToNewDataModel = () => {
    const { EditableDocModel, BillAddress, ShipAddress, DocHeader } = this.props;
    EditableDocModel.street = BillAddress.Street ?? '';
    EditableDocModel.county = BillAddress.County ?? '';
    EditableDocModel.city = BillAddress.City ?? '';
    EditableDocModel.block = BillAddress.Block ?? '';
    EditableDocModel.zipCode = BillAddress.ZipCode ?? '';

    EditableDocModel.shipStreet = ShipAddress.Street ?? '';
    EditableDocModel.shipCounty = ShipAddress.County ?? '';
    EditableDocModel.shipCity = ShipAddress.City ?? '';
    EditableDocModel.shipBlock = ShipAddress.Block ?? '';
    EditableDocModel.shipZipCode = ShipAddress.ZipCode ?? '';

    EditableDocModel.rfc = DocHeader.LicTradNum ?? '';
    this.RefreshDocModel(EditableDocModel)
  }

  async componentDidUpdate(prevProps) {
    if (this.props.EditableMode !== prevProps.EditableMode) {
      await this.EqualDataToNewDataModel();
      return true;
    }
  }

  timeFormat = () => {
    const { DocHeader } = this.props;
    let timeFormat = '';
    if (DocHeader.CreateTS) {
      let time = (DocHeader.CreateTS || '').toString();
      if (time.length > 0) {
        let seconds = time.length - 2;
        let minutes = time.length - 4;
        timeFormat = time.slice(0, minutes) + ":" + time.slice(minutes, seconds) + ":" + time.slice(seconds, time.length)
      }
    }
    return timeFormat;
  }

  taxSystem = (key) => {
    let name="";
    switch (key) {
      case "601":
        name = "General de Ley Personas Morales"
      break;
  
      case "603":
        name = "Personas Morales con Fines no Lucrativos"
      break;
  
      case "605":
        name = "Sueldos y Salarios e Ingresos Asimilados a Salarios"
      break;
  
      case "606":
        name = "Arrendamiento"
      break;
  
      case "607":
        name = "Régimen de Enajenación o Adquisición de Bienes"
      break;
  
      case "608":
        name = "Demás ingresos"
      break;
  
      case "610":
        name = "Residentes en el Extranjero sin Establecimiento Permanente en México"
      break;
  
      case "611":
        name = "Ingresos por Dividendos (socios y accionistas)"
      break;
  
      case "612":
        name = "Personas Físicas con Actividades Empresariales y Profesionales"
      break;
  
      case "614":
        name = "Ingresos por intereses"
      break;
  
      case "615":
        name = "Régimen de los ingresos por obtención de premios"
      break;
  
      case "616":
        name = "Sin obligaciones fiscales"
      break;
  
      case "620":
        name = "Sociedades Cooperativas de Producción que optan por diferir sus ingresos"
      break;
  
      case "621":
        name = "Incorporación Fiscal"
      break;
  
      case "622":
        name = "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras"
      break;
  
      case "623":
        name = "Opcional para Grupos de Sociedades"
      break;
  
      case "624":
        name = "Coordinados"
      break;
  
      case "625":
        name = "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas"
      break;
  
      case "626":
        name = "Régimen Simplificado de Confianza"
      break;
    
      default:
        break;
    }
    return name;
  }

  render() {
    const { EditableMode, DocLines, DocHeader, EditableDocModel, BillAddress, ShipAddress, EditParam1, InfoByFolio, reprint, user, time} = this.props;

    let linesForAllInOne =10;
    let linesfirstPage = 51;
    let linesfullPage = 71;

    let remainingLines = (DocLines.length-linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length-linesfirstPage)/linesfullPage));
    let totalPages = Math.ceil( (DocLines.length - linesfirstPage) / linesfullPage );
    
    let countLines=1;
    let countLines2=1;

    let extraTables = [];
    
    for (let index = 0; index < totalPages; index++) {
        extraTables.push (this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio))
    }
    let XML = {};
    let xml = DocHeader.U_FMB_XMLTIMBRA ? DocHeader.U_FMB_XMLTIMBRA.includes('UUID') ? JSON.parse(DocHeader.U_FMB_XMLTIMBRA) : null : DocHeader.U_SO1_02XMLSELLADO ? DocHeader.U_SO1_02XMLSELLADO.includes('UUID') ? JSON.parse(DocHeader.U_SO1_02XMLSELLADO) : null: null;
    XML ={
      isTimbra: xml ? true : false,
      info: xml
    }

    let cadenaQR = '';
    let cfdiCaComplemento = '';
    let cfdiComplemento = null;
    let cfdiConcepto = [];
    let totalLetra = '';
    let docType = '';
    let documentosRelacionados = [];
    if(xml){
      cadenaQR = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=` +
                  xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID + `&re=` +
                  xml.cfdiEmisor._attributes.Rfc + `&rr=` +
                  xml.cfdiReceptor._attributes.Rfc + `&tt=` +
                  xml._attributes.Total + `&fe=` +
                  xml._attributes.Sello.substring(xml._attributes.Sello.length - 8, xml._attributes.Sello.length);

    cfdiCaComplemento =
            "|" +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.Version +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.RfcProvCertif +
            "|" +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD +
            "|" +
            xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT +
            "|" +
            "|";

            let numeroLetra = new NumeroLetra();
            totalLetra = numeroLetra.NumeroALetras(xml._attributes.Moneda, Number(Number(DocHeader.DocTotal).toFixed(2)));
            docType = 'Complemento de pago';
            documentosRelacionados = xml.cfdiComplemento['pago20:Pagos']['pago20:Pago'].length > 0 ? xml.cfdiComplemento['pago20:Pagos']['pago20:Pago'] : [xml.cfdiComplemento['pago20:Pagos']['pago20:Pago']];
            cfdiConcepto = [xml.cfdiConceptos.cfdiConcepto._attributes];
    }
    
    return (
      <>
     
          <table><tr><td>
            <div id="printInvoice" >
              <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>
                {DocLines.length <= linesForAllInOne &&
                  <div className='text-right' style={{ fontSize: "14px" }}>
                    <table>
                      <tbody>
                          <tr>
                            <td className='text-right'>
                              {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                  </div>
                }
                <div className="row">
                  <div className="col-3">
                    <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />

                    <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />
                      {/* <span className="text-center">{user.Timbra.RFC || ''}</span><br /> */}
                      <strong>{Datos_Empresa.RFC}</strong></p>

                    {/* <span className="text-left">Teléfono(s): {user.Branch.Phone || ''}</span> */}
                    <p style={{ fontSize:'11px' }}><strong>601-Régimen General de Ley Personas Morales</strong><br/>{user.Branch.Address}.<br/>
                    <span className="text-left">Teléfono(s): {user.Branch.Phone}</span></p>
                    {/* <p className="text-center"><br/>{user.Branch.Address || ''}</p> */}
                    <p className="text-center"></p>
                  </div>
                  <div className="col-9">
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Serie</th>
                          <th className="text-center">Doc</th>
                          <th className="text-center">Número de certificado:</th>
                          <th className="text-center">Fecha - Hora emisión</th>
                          <th className="text-center">Lugar de expedición</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.Serie : ''}</td>
                          <td className="text-center">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.NoCertificado : ''}</td>
                          <td className="text-center">{`${XML.isTimbra ? XML.info._attributes.Fecha :''}`}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.LugarExpedicion : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Folio Fiscal:</th>
                          <th className="text-center">Certificado SAT:</th>
                          <th className="text-center">Fecha y Hora de Certificación:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center" style={{ fontsize: "3vw" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Cliente:</th>
                          <th className="text-center">Uso CFDI</th>
                          <th className="text-center">Asesor de ventas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{!!DocHeader.CardCode && DocHeader.CardCode} - {XML.isTimbra ? XML.info.cfdiReceptor._attributes.Nombre : !!DocHeader.CardName && DocHeader.CardName}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.UsoCFDI : ''}</td>
                          <td className="text-center">{DocHeader.SlpName || ''} </td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Tipo Documento</th>
                          <th className="text-center">Régimen</th>
                          <th className="text-center">R.F.C.</th>
                          <th className="text-center">Moneda</th>
                          <th className="text-center">Folio</th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                          <tr>
                            <td className="text-center">{docType}</td>
                            <td className="text-center">{!!DocHeader.U_FMB_REGIMEN_FISCAL && DocHeader.U_FMB_REGIMEN_FISCAL}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Rfc : ''}</td>
                            <td className="text-center">{documentosRelacionados.length > 0 ? documentosRelacionados[0]._attributes.MonedaP : XML.isTimbra ? XML.info._attributes.Moneda : ''}</td>
                            <td className="text-center"><strong>{DocHeader.U_FMB_FOLIO_COUNTER || DocHeader.DocNum || ''}</strong></td>
                          </tr>
                        
                      }
                        


                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row' style={{ paddingRight: "15px" }}>
                  <div className='col-4'>
                      <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                  </div>
                  <div className='col-4'>
                      <div className="text-center" style={{fontSize: "14px", fontWeight: "bold"}}>Abono de cobranza</div>
                  </div>
                  <table>
                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <tr>
                        <th className="text-center" colSpan={2}>DOMICILIO DE FACTURACIÓN</th>
                        <th className="text-center" colSpan={2} style={{ width: "18.75vw" }}>Forma de pago</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ borderLeft: "solid 1px" }}>
                        <td className="text-center" colSpan={2}>
                          {true ?
                            (DocHeader.Address)
                            :
                            <>
                              <table>
                                <thead>
                                  <tr>
                                    <th className="text-center">CALLE </th>
                                    <th className="text-center">ESTADO </th>
                                    <th className="text-center">CIUDAD </th>
                                    <th className="text-center">COLONIA </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr style={{ borderLeft: "solid 1px" }}>
                                    <td className="text-center">
                                      <input type="text"
                                        placeholder='CALLE'
                                        value={EditableDocModel.street ?? ''}
                                        onChange={(event) => this.OnchangeBillStreet(event.target.value)}
                                      >
                                      </input>
                                    </td>
                                    <td className="text-center">
                                      <input type="text"
                                        placeholder='ESTADO'
                                        value={EditableDocModel.county}
                                        onChange={(event) => this.OnchangeBillCounty(event.target.value)}
                                      >
                                      </input>
                                    </td>
                                    <td className="text-center">
                                      <input type="text" placeholder='CIUDAD'
                                        value={EditableDocModel.city}
                                        onChange={(event) => this.OnchangeBillCity(event.target.value)}
                                      ></input>
                                    </td>
                                    <td className="text-center">
                                      <input type="text" placeholder='COLONIA'
                                        value={EditableDocModel.block}
                                        onChange={(event) => this.OnchangeBillBlock(event.target.value)}
                                      ></input></td>

                                  </tr>
                                </tbody>
                              </table>
                            </>
                          }
                        </td>
                        <td className="text-center" style={{ border: "solid 1px" }}>{cfdiComplemento ? cfdiComplemento.FormaDePagoP : DocHeader.U_B1SYS_PmntMethod}</td>
                        {/* <td className="text-center" style={{ border: "solid 1px" }}>{XML.isTimbra ? XML.info._attributes.MetodoPago : ''}</td> */}
                      </tr>
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr style={{ borderLeft: "solid 1px" }}>
                        <th className="text-center" style={{ width: "300px" }}>Fecha de vencimiento</th>
                        <th className="text-center" style={{ width: "300px", background: Datos_Empresa.BackgroundColor, color: "white" }}>Nombre del capturista</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ borderLeft: "solid 1px", borderBottom: "solid 1px" }}>
                        <td className="text-center" style={{ border: "solid 1px" }}>{!!DocHeader.DocDueDate && moment(DocHeader.DocDueDate).format("YYYY-MM-DD")}</td>
                        <td className="text-center" style={{ border: "solid 1px" }}>{DocHeader.U_FMB_User || ''}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table className='mt-2'>
                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <tr>
                        <th>Cantidad</th>
                        <th>Unidad de medida</th>
                        <th className="text-center">Código SAT</th>
                        <th className="text-center">Descripción</th>
                        <th className="text-center">Tasa</th>
                        <th className="text-right">Precio U</th>
                        {/* <th className="text-center">Descuento %</th> */}
                        <th className="text-right">Importe </th>
                      </tr>
                    </thead>
                    <tbody style={{ border: "solid 1px" }}>
                      {!!cfdiConcepto && Array.isArray(cfdiConcepto) && cfdiConcepto.length > 0 &&
                        cfdiConcepto.map((docLine) => {//51 es el limite de la primera pagina
                          if (countLines < 52) {
                            countLines++
                            return (
                              <>
                                <tr style={{ fontSize: '12px' }}>
                                  <td>{docLine.Cantidad ?? ''}</td>
                                  <td>{docLine.ClaveProdServ ?? ''}</td>
                                  <td className="text-center">{docLine.ClaveUnidad ?? ''}</td>
                                  <td className="text-center">{ docLine.Descripcion ?? ''}</td>
                                  <td className="text-center">{0}</td>
                                  <td className="text-right">{formatNumber.new(0) ?? ''}</td>
                                  {/* <td className="text-center">{0}%</td> */}
                                  <td className="text-right">{formatNumber.new( 0)}</td>
                                </tr>
                                {docLine.U_FMB_LineComment != ""?
                                  <tr style={{ fontSize: '12px' }}>
                                      <td ></td>
                                      <td colSpan={6}><strong>Comentario: </strong>{docLine.U_FMB_LineComment}</td>
                                  </tr>
                                  :""
                                }
                              </>
                            );
                          }else{
                            return("");
                          }
                        })
                      }
                    </tbody>
                  </table>
                </div>
               
                <div className='row mt-2'>
                  <div className='col-8'>
                    <p style={{ marginLeft: "-13px", fontSize: '12px' }}>
                      Comentarios:<br />
                      TODA DEVOLUCIÓN CAUSARÁ UN CARGO DEL 10% DEL TOTAL DE LA FACTURA POR GASTOS ADMINISTRATIVOS.<br />
                      NO ACEPTAMOS DEVOLUCIONES NI CANCELACIONES DESPUÉS DE 7 DÍAS, SIN EXCEPCIONES.<br />
                      EFECTOS FISCALES AL PAGO. ESTA FACTURA SERÁ PAGADA EN UNA SOLA EXHIBICIÓN. <br />
                      <strong>Régimen fiscal del receptor: {(!! DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "" )+ "-" + this.taxSystem(!! DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "")}.</strong><br />
                      {totalLetra} {XML.isTimbra ? XML.info._attributes.Moneda : ''}
                    </p>
                  </div>
                  <div className='col-4'>
                    <table>
                      <tbody style={{ fontSize: '12px' }}>
                        <tr>
                          <td className='text-right'><strong>Subtotal: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "6.25vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Descuento: %</strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{formatNumber.new(DocHeader.DiscPrcnt) ?? 0}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>Descuento: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum) ?? ''}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Retención: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{''}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>Total: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>


                <div className="row" style={{paddingRight: "15px"}}>
                    <table className="mt-2">
                        <thead style={{background: Datos_Empresa.BackgroundColor, color: "white", fontSize: "10px"}}>
                            <tr>
                                <th className="text-center" colspan="12">Complemento de Pago</th>
                            </tr>
                        </thead>
                        <tbody style={{border: "1px solid"}}>
                          {documentosRelacionados.length > 0 &&
                            documentosRelacionados.map((docRelacionado)=>{
                              return (
                                <tr style={{fontsize: "9px"}}>
                                  <td className="text-center"><strong>Fecha de Pago: </strong></td>
                                  <td className="text-center" style={{fontsize: "9px"}}>{docRelacionado._attributes.FechaPago || ''}</td>
                                  <td className="text-center"><strong>Forma de Pago: </strong></td>
                                  <td className="text-center" style={{fontsize: "9px"}}>
                                    <span className="auto-style19">{docRelacionado._attributes.FormaDePagoP || ''}</span>
                                  </td>
                                  <td className="text-center"><strong>Monto: </strong></td>
                                  <td className="text-center" style={{fontsize: "9px"}}>{docRelacionado._attributes.Monto || ''}</td>
                              </tr>
                              )
                            })
                          }
                            
                        </tbody>
                    </table>
                </div>
                
                
               
                <div className="row" style={{paddingRight: "15px"}}>
                    <table className="mt-2">
                        <thead style={{background: Datos_Empresa.BackgroundColor, color: "white", fontSize: "10px"}}>
                            <tr>
                                <th className="text-center" colspan="12">Documentos Relacionados</th>
                            </tr>
                            <tr>
                                <th className="text-center">Folio</th>
                                <th className="text-center">Parcialidad</th>
                                <th className="text-center">Saldo Anterior</th>
                                <th className="text-center">Importe Pagado</th>
                                <th className="text-center">Saldo Insoluto</th>
                                <th className="text-center">Id Documento</th>
                            </tr>
                        </thead>
                        <tbody style={{border: "1px solid"}}>
                          {documentosRelacionados.length > 0 &&
                            documentosRelacionados.map((documento)=>{
                              let docRelacionado = documento['pago20:DoctoRelacionado'].length > 1 ? documento['pago20:DoctoRelacionado'] : [documento['pago20:DoctoRelacionado']]
                               return docRelacionado.map((doc)=>{
                                  return (
                                    <tr style={{fontSize: '10px'}}>
                                      <td className="text-center">{doc._attributes.Folio || ''}</td>
                                      <td className="text-center">{doc._attributes.NumParcialidad || ''}</td>
                                      <td className="text-center">${doc._attributes.ImpSaldoAnt || 0}</td>
                                      <td className="text-center">${doc._attributes.ImpPagado || 0}</td>
                                      <td className="text-center">${doc._attributes.ImpSaldoInsoluto || 0}</td>
                                      <td className="text-center">{doc._attributes.IdDocumento || ''}</td>
                                    </tr>
                                  )
                                })
                            })
                          }
                            
                        </tbody>
                    </table>
                </div>
                                    


                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                  <div className='col-12' style={{ border: "solid 1px" }}>
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center"></th>
                          <th className="text-center">Este documento es una impresión de un comprobante fiscal digital</th>
                          <th className="text-center">Este documento es una representación impresa de un CFDI</th>
                          <th className="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-left" colSpan={3}>
                            <strong>Sello digital autorizado:</strong><br />
                            <p class='digitalStamp' style={{ marginBottom: "-5px" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD : ''}</p>
                          </td>
                          <td className="text-center" rowSpan={2}>
                            <QRCodeSVG
                              value={cadenaQR}
                              height={92}
                              width={92}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left" colSpan={3}><strong>Sello digital SAT:</strong>
                            <p className='digitalStamp' style={{ marginBottom: "-5px" }}>
                              {XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloSAT : ''}
                            </p>
                          </td>

                        </tr>
                        <tr>
                          <td className="text-left" colSpan={4}>
                            <strong>Cadena original:</strong>
                            <p className='digitalStampAlt' style={{ marginBottom: "5px" }}>{cfdiCaComplemento}</p>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </td></tr></table>
      </>
    )
  }
}

export default CollectInvoice